export default "__VITE_PUBLIC_ASSET__f298ca16__"